/* eslint-disable react/jsx-max-props-per-line */
import { Checkbox, Collapse, ListItem, List, Grid, makeStyles, Typography, IconButton, Tooltip, Theme, Box } from '@material-ui/core';
import { useSidebarListStyles } from 'components/SidebarList';
import SharedRepoRecepientDTO from 'dto/SharedRepoRecepientDTO';
import React from 'react';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import DatasetDTO from 'dto/DatasetDTO';
import GetAppIcon from '@material-ui/icons/GetApp'
import VisibilityIcon from '@material-ui/icons/Visibility'
import repos from 'services/repositories'

interface ImportDatasetModalItemProps {
  defaultOpen?: boolean
  checked: Set<number>
  setChecked: (newState: Set<number>) => void
  repo: SharedRepoRecepientDTO
  setOpenDataset: React.Dispatch<React.SetStateAction<DatasetDTO | null>>
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'block'
  },
  icon: {
    marginLeft: 'auto'
  },
  itemActions: {
    '&>*:not(:last-child)': {
      marginRight: theme.spacing(1)
    },
  },
  itemActionsButton: {
    opacity: 0,
    transition: 'opacity 300ms'
  },
  item: {
    '&:hover': {
      background: theme.palette.background.default
    },
    '&:hover $itemActionsButton': {
      opacity: 1
    }
  }
}))

const ImportDatasetModalItem = (props: ImportDatasetModalItemProps) => {
  const listClasses = useSidebarListStyles();
  const classes = useStyles();
  const {checked, defaultOpen = false, setChecked, repo, setOpenDataset} = props;

  const [open, setOpen] = React.useState<boolean>(defaultOpen);
  const numChecked = repo.datasets.reduce((acc, curr) => checked.has(curr.id) ? acc+1:acc, 0);
  const allChecked = numChecked === repo.datasets.length

  const handleToggleGroup = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = new Set<number>(checked);
    if(e.target.checked) {
      repo.datasets.forEach(d => newChecked.add(d.id))
    } else {
      repo.datasets.forEach(d => newChecked.delete(d.id))
    }
    setChecked(newChecked);
  }

  const toggleSingle = (e: React.ChangeEvent<HTMLInputElement>,id: number) => {
    const newChecked = new Set<number>(checked);
    if(e.target.checked) {
      newChecked.add(id);
    } else {
      newChecked.delete(id);
    }
    setChecked(newChecked);
  }

  return <ListItem
    className={clsx(listClasses.item, allChecked && listClasses.itemActive, classes.root)}
    divider
    disableGutters
  >
    <Grid 
      alignItems='center' 
      container 
    >
      <Checkbox
        checked={allChecked}
        indeterminate={!allChecked && numChecked > 0}
        onChange={handleToggleGroup}
        value={allChecked}
      />
      <Tooltip 
        title={<div style={{textAlign: 'center'}}>Shared by {repo.ownerFirstName} {repo.ownerLastName}<br/>{repo.ownerLoginID}</div>}
      >
        <Typography variant='h6'>{repo.repoName}</Typography>
      </Tooltip>
      <IconButton className={classes.icon} onClick={() => setOpen(!open)}>
        {open ? <ExpandLessIcon/>:<ExpandMoreIcon/>}
      </IconButton>
    </Grid>
    <div>
      <Collapse in={open}>
        <Box p={1} paddingLeft={3.5} style={{background: '#eee'}}>
          <Grid alignItems='center' container>
            <Grid alignItems='center' className={classes.itemActions} container item xs={4}>
              <Typography variant='h6'>
                Name
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant='h6'>
                Title
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant='h6'>
                Description
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant='h6' align='center'>
                Rows
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant='h6' align='center'>
                Columns
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <List>
          {repo.datasets.map(d => <ListItem
            className={clsx(classes.item, listClasses.item, checked.has(d.id) && listClasses.itemActive)}
            key={d.id}
          >
            <Checkbox
              checked={checked.has(d.id)}
              onChange={(e) => toggleSingle(e, d.id)}
              value={checked.has(d.id)}
            />
            <Grid alignItems='center' container>
              <Grid alignItems='center' className={classes.itemActions} container item xs={4}>
                <Typography>
                  {d.name}
                </Typography>
                <Tooltip title='Download data'>
                  <IconButton className={classes.itemActionsButton} onClick={() => repos.downloadData(d)} size='small'>
                    <GetAppIcon/>
                  </IconButton>
                </Tooltip>
                <Tooltip title='Preview data'>
                  <IconButton className={classes.itemActionsButton} onClick={() => setOpenDataset(d)} size='small'>
                    <VisibilityIcon/>
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={2}>
                <Typography>
                  {d.title}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Tooltip title={d.description}>
                  <Typography>
                    {d.description ? d.description.substring(0,35) + (d.description.length > 35 ? '...' : '') : ''}
                  </Typography>
                </Tooltip>
              </Grid>
              <Grid item xs={1}>
                <Typography align='center'>
                  {d.rowCount}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography align='center'>
                  {d.colCount}
                </Typography>
              </Grid>
            </Grid>
          </ListItem>)}
        </List>
      </Collapse>
    </div>
  </ListItem>
}

export default ImportDatasetModalItem